import { Box } from "@mui/material";
import { SwitchWithDescription } from "@shared/components";
import { InvoiceSwitchesProps } from "../utils/types";

const InvoiceSwitches = ({ formikProps }: InvoiceSwitchesProps) => {
  const formikPropsForSwitch = {
    values: formikProps.values,
    touched: formikProps.touched,
    errors: formikProps.errors,
    setFieldValue: formikProps.setFieldValue,
    setFieldTouched: formikProps.setFieldTouched,
  };

  const switchConfigs = [
    {
      name: "activityState",
      label: "Is Active",
      description: "Controls the active/inactive state for the party",
    },
    {
      name: "campaignLimitedDataTransfer",
      label: "Campaign Limit Data Transfer",
      description: "Enable to limit data transfer by campaign",
    },
  ] as const;

  return (
    <>
      {switchConfigs.map(({ name, label, description }) => (
        <Box key={name}>
          <SwitchWithDescription
            name={name}
            label={label}
            description={description}
            formik={formikPropsForSwitch}
          />
        </Box>
      ))}
    </>
  );
};

export default InvoiceSwitches;
